import { useEffect, useState } from 'react';
import { StreamKey } from '../types';
import { CAPTION_RTMP_API_URL } from '../config';

export function useGetStreamKeys(userId: string, accessToken: string, deps: any[] = []) {
  const [streamKeys, setStreamKeys] = useState<StreamKey[]>([]);
  useEffect(() => {
    const getStreamKeysForUser = async () => {
      try {
        const response = await fetch(`${CAPTION_RTMP_API_URL}/stream_keys/${userId}`, {
          headers: { authorization: `Bearer ${accessToken}` },
        });
        const json = await response.json();
        if (!Array.isArray(json)) {
          console.error('Failed to receive stream keys.');
          return;
        }

        const receivedStreamKeys: StreamKey[] = json.map(
          (item: any) =>
            ({
              option: {
                value: item.public_id,
                label: item.public_id,
              },
              keyVal: item.key,
            }) as StreamKey,
        );
        setStreamKeys(receivedStreamKeys);
      } catch (e) {
        console.error('Could not fetch stream keys', e);
        setStreamKeys([]);
      }
    };
    if (streamKeys.length === 0) getStreamKeysForUser();
  }, [streamKeys.length, ...deps]);
  return streamKeys;
}
